import get from 'lodash/get'

export function determinations({ account }) {
  const isBacker = get(account, ['isBacker'], false)
  const isFree = get(account, ['isFree'], false)
  const isBeingImpersonated = get(account, ['impersonating'], false)

  const hasSubscription = get(account, ['subscription'], null) !== null

  const hasActiveSubscription = get(account, ['subscription'], null) !== null && get(account, ['subscription', 'status']) === 'active'

  const hasCanceledSubscription = get(account, ['subscription'], null) !== null && get(account, ['subscription', 'status']) === 'canceled'

  const hasFreeSubscription = get(account, ['subscription'], null) !== null && get(account, ['subscription', 'type']) === 'free'

  const hasProSubscription = get(account, ['subscription'], null) !== null && get(account, ['subscription', 'type']) !== 'free'

  const showBackerServicesShutdownWarning = isBacker && !hasSubscription && get(account, ['backerServicesShutdownWarningActive'], false)

  const showBackerGracePeriodWarning = isBacker && !hasSubscription && get(account, ['backerGracePeriodActive'], false)

  const haveBackerServicesExpired = isBacker && !hasSubscription && get(account, ['backerServicesExpired'], false)

  return {
    isBacker,
    isFree,
    isBeingImpersonated,
    hasSubscription,
    hasActiveSubscription,
    hasCanceledSubscription,
    hasFreeSubscription,
    hasProSubscription,
    showBackerServicesShutdownWarning,
    showBackerGracePeriodWarning,
    haveBackerServicesExpired
  }
}
